import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'events-section',
  templateUrl: './events-section.component.html',
  styleUrls: ['./events-section.component.scss']
})
export class EventsSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
